import Styles from "./RA.module.css";
import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  getequisitionsBidders,
  getequisitionsList,
  getDocumentTenderRes,
  getRaArchive,
} from "../../../Services/ReverseAuction/GetApi";
import { activeTenderId } from "../../../Redux/Slices/auctionSlice";
import { formatDate, formatSlotTime } from "../../../helpers/dateFormat";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchMainScreenActiveConnection } from "../../../Redux/Slices/CapacitySlice";
import { getMainScreenConnectionDetails } from "../../../Services/BuySell/Listing";
import LoadMorePagination from "../../LoadeMore";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import ViewBids from "../../Modals/ReverseAuction/ViewBids/ViewBids";
import Charges from "../../Modals/ConGen/Charges/Charges";
import ViewDoc from "../../Modals/ConGen/ViewDoc/ViewDoc";
import RABidHistory from "../../RA_Common/RABidHistory/RABidHistory";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { convertDate } from "../../../commons/FormatDate";

// sessionStorage key used to remember which archive listing was expanded so it
// can be restored after navigating to /tender_active and coming back.
const EXPANDED_TENDER_KEY = "raArchiveExpandedTenderId";

const LoaderNoData = ({ loading, dataLength }) => {
  if (loading) {
    return (
      <div className={Styles.loaderContainer}>
        <div className={Styles.loader} role="status" aria-label="loading" />
      </div>
    );
  }
  if (!loading && dataLength === 0) {
    return <div className={Styles.noDataContainer}>No records found</div>;
  }
  return null;
};

const SummaryHeader = ({ status }) => (
  <div
    className={Styles.accordionSummaryContainer}
    style={{
      position: "sticky",
      top: 0,
      zIndex: 10,
      backgroundColor: "#fffaf6",
    }}
  >
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "30%" }} />
        <col style={{ width: "25%" }} />
        <col
          style={{ width: status?.toLowerCase() === "expired" ? "20%" : "25%" }}
        />
        {status?.toLowerCase() === "expired" && (
          <col style={{ width: "20%" }} />
        )}
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>E.Tender Number</th>
          <th className={Styles.summaryHeaderCell}>E.RA Number</th>
          <th className={Styles.summaryHeaderCell}>Tender Duration</th>
          {status?.toLowerCase() === "expired" && (
            <th className={Styles.summaryHeaderCell}>Expiry Date & Time</th>
          )}
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryInnerHeader = ({ status }) => {
  const isWithdrawn = status?.toLowerCase() === "withdrawn";
  return (
    <div
      style={{ marginBottom: "10px" }}
      className={Styles.accordionSummaryContainer}
    >
      <table
        className={Styles.summaryTable}
        style={{ tableLayout: "fixed", width: "100%" }}
      >
        <colgroup>
          {isWithdrawn ? (
            <>
              <col style={{ width: "15%" }} />
              <col style={{ width: "30%" }} />
              <col style={{ width: "28%" }} />
              <col style={{ width: "27%" }} />
            </>
          ) : (
            <>
              <col style={{ width: "14%" }} />
              <col style={{ width: "12%" }} />
              <col style={{ width: "24%" }} />
              <col style={{ width: "16%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "14%" }} />
            </>
          )}
        </colgroup>
        <thead className={Styles.summaryHeader}>
          <tr>
            {!isWithdrawn && (
              <th className={Styles.summaryInnerHeaderCell}>Contract ID</th>
            )}
            <th className={Styles.summaryInnerHeaderCell}>Start & End Date</th>
            <th className={Styles.summaryInnerHeaderCell}>Start & End Time</th>
            <th className={Styles.summaryInnerHeaderCell}>Req. Qty (MW)</th>
            {!isWithdrawn && (
              <th className={Styles.summaryInnerHeaderCell}>
                Lowest Bid (MW / ₹/kWh)
              </th>
            )}
            <th className={Styles.summaryInnerHeaderCell}>Bid History</th>
          </tr>
        </thead>
      </table>
    </div>
  );
};
const SummaryInnerClosedHeader = ({ role }) => (
  <div
    style={{ marginBottom: "10px" }}
    className={Styles.accordionSummaryContainer}
  >
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "16%" }} />
        <col style={{ width: "14%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "14%" }} />
        <col style={{ width: "20%" }} />
        <col style={{ width: "14%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryInnerHeaderCell}>Contract ID</th>
          <th className={Styles.summaryInnerHeaderCell}>Start & End Date</th>
          <th className={Styles.summaryInnerHeaderCell}>Start & End Time</th>
          <th className={Styles.summaryInnerHeaderCell}>Req. Qty (MW)</th>
          <th className={Styles.summaryInnerHeaderCell}>
            Lowest Bid (MW / ₹/kWh)
          </th>
          <th className={Styles.summaryInnerHeaderCell}>Bid History</th>
        </tr>
      </thead>
    </table>
  </div>
);

function formatCustomDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const time =
    hours === "23" && minutes === "59" ? "24:00" : `${hours}:${minutes}`;
  return `${day} ${month} ${year} ${time}`;
}

const SummaryRow = ({
  ele,
  index,
  expanded,
  onToggle,
  reqData,
  reqLoading,
  status,
}) => {
  console.log("Rendering SummaryRow", { ele });
  const showLoader = reqLoading;
  const location = useLocation();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const params = new URLSearchParams(location.search);
  let showStatusButtons = params.get("status") === "Closed" ? true : false;

  const mainScreenMatchData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [bidsModal, setBidsModal] = useState(false);
  const [chargesModal, setChargesModal] = useState(false);
  const [docsModal, setDocsModal] = useState(false);
  const [bidHistoryModal, setBidHistoryModal] = useState(false);
  const [selectedRequisitionId, setSelectedRequisitionId] = useState(null);
  const [listingStatus, setListingStatus] = useState(null);
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  const userId = useSelector(
    (state) => state?.persistedReducer?.user?.user?.userId,
  );

  const isInitiator = Number(ele?.createdBy) === userId;

  useEffect(() => {
    if (expanded !== index || ele?.tenderStatus !== "TERMS") return;
    const capId = ele?.capacityId ?? ele?.generatorCapacityId;
    if (!capId) return;
    getMainScreenConnectionDetails(capId)
      .then((res) => {
        if (res?.data?.code === 200) {
          const d = res.data.data;
          setListingStatus(d?.page?.[0] ?? d);
        }
      })
      .catch(() => {});
  }, [
    expanded,
    index,
    ele?.tenderStatus,
    ele?.capacityId,
    ele?.generatorCapacityId,
    role,
  ]);

  const connection = expanded === index ? mainScreenMatchData?.[0] : null;
  // Contract ID comes from the connection detail API (bsbp/connection/get),
  // fetched into Redux for the expanded tender, not from the requisition list.
  const contractId = connection?.contractUniqueId;
  const isWithdrawn = status?.toLowerCase() === "withdrawn";

  const selectedBids =
    reqData?.flatMap((item) =>
      role === "consumer"
        ? showStatusButtons
          ? (item?.bids || []).filter(
              (bid) =>
                bid.winnerBidStatus === "AWARDED" ||
                bid.winnerBidStatus === "ACCEPTED",
            )
          : item?.bids || []
        : item?.selfBid
          ? [item.selfBid]
          : [],
    ) || [];

  function formatExpireDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const time =
      hours === "23" && minutes === "59" ? "24:00" : `${hours}:${minutes}`;
    return `${day}-${month}-${year} ${time}`;
  }

  const systemTnCUrl =
    "https://otc2-dev.s3.ap-south-1.amazonaws.com/assets/GNA+Energy+-+System+T%26C+-+RFP_RFQ.pdf";

  const handleDownloadTenderRes = async () => {
    try {
      const response = await getDocumentTenderRes(ele?.id);
      if (!response?.data) return;
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `tender_${ele?.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Error downloading tender result:", e);
    }
  };

  if (!ele) return null;
  return (
    <>
      {bidsModal && (
        <ViewBids
          open={bidsModal}
          handleClose={() => setBidsModal(false)}
          data={selectedBids}
        />
      )}
      {chargesModal && (
        <Charges
          open={chargesModal}
          onClose={() => setChargesModal(false)}
          contractId={connection?.id}
          userLevel={!connection?.id}
          hideCounterParty
        />
      )}
      {docsModal && (
        <ViewDoc
          connectionId={connection?.id}
          open={docsModal}
          handleClose={() => setDocsModal(false)}
        />
      )}
      <RABidHistory
        open={bidHistoryModal}
        handleClose={() => {
          setBidHistoryModal(false);
          setSelectedRequisitionId(null);
        }}
        tenderId={ele?.id}
        requisitionId={selectedRequisitionId}
        showEntityName={showStatusButtons || ele?.tenderStatus === "TERMS"}
        role={role}
      />
      <PdfPreviewModal />
      <div
        className={expanded === index ? "" : Styles.detailsMainDrop_inactive}
      >
        <Accordion
          style={{
            backgroundColor: "#f3f5f8",
            marginTop: index === 0 ? "0px" : "3px",
            border:
              expanded === index
                ? "1px solid var(--primary-color-text)"
                : "none",
            borderRadius: "10px",
          }}
          expanded={expanded === index}
          onChange={() => onToggle(index)}
        >
          <AccordionSummary
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            <div className={Styles.accordionSummaryContainer}>
              <table
                className={Styles.summaryTable}
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "30%" }} />
                  <col style={{ width: "25%" }} />
                  <col
                    style={{
                      width:
                        status?.toLowerCase() === "expired" ? "20%" : "25%",
                    }}
                  />
                  {status?.toLowerCase() === "expired" && (
                    <col style={{ width: "20%" }} />
                  )}
                </colgroup>
                <tbody>
                  <tr>
                    <td className={Styles.summaryCell}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        <ExpandMoreIcon
                          style={{ fontSize: "18px" }}
                          className={`${Styles.expandIconLeft} ${
                            expanded === index ? Styles.rotateIcon : ""
                          }`}
                        />
                        {index + 1}
                      </div>
                    </td>
                    <td className={Styles.summaryCell}>{ele?.tenderNumber}</td>
                    <td className={Styles.summaryCell}>{ele?.auctionNumber}</td>
                    <td className={Styles.summaryCell}>
                      {formatCustomDate(ele?.tenderStartDateTime)} -{" "}
                      {formatCustomDate(ele?.tenderCloseDateTime)}
                    </td>
                    {status?.toLowerCase() === "expired" && (
                      <td className={Styles.summaryCell}>
                        {formatExpireDate(ele?.expireAt)}
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionSummary>

          <AccordionDetails
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            {/* details wrapper: show loader inside this container */}
            <div
              style={{
                border: "1px solid var(--primary-color-text)",
                margin: "0px 10px 10px 10px",
              }}
              className={Styles.accordionDetailsContainerUploadDocs}
            >
              {showLoader && (
                <div className={Styles.loaderContainer}>
                  <div
                    className={Styles.loader}
                    role="status"
                    aria-label="loading connection"
                  />
                </div>
              )}
              {!showLoader && (
                <>
                  {Array.isArray(reqData) && reqData.length ? (
                    <>
                      {params.get("status") === "Closed" ? (
                        <SummaryInnerClosedHeader role={role} />
                      ) : (
                        <SummaryInnerHeader status={status} />
                      )}

                      <div style={{ padding: "10px" }}>
                        <div
                          style={{
                            border: "1px solid #DFEAF2",
                            padding: "5px",
                            borderRadius: "8px",
                          }}
                        >
                          {params.get("status") === "Closed" ? (
                            <>
                              {role === "consumer" ? (
                                <>
                                  {reqData.map((item, idx) => {
                                    // Show every requisition returned by the API,
                                    // regardless of whether it has an awarded bid.
                                    // Displayed values are requisition-level, so one
                                    // row is rendered per requisition.
                                    return (
                                      <React.Fragment key={idx}>
                                        <table
                                          className={Styles.summaryTable}
                                          style={{
                                            tableLayout: "fixed",
                                            width: "100%",
                                          }}
                                        >
                                          <colgroup>
                                            <col style={{ width: "16%" }} />
                                            <col style={{ width: "14%" }} />
                                            <col style={{ width: "22%" }} />
                                            <col style={{ width: "14%" }} />
                                            <col style={{ width: "20%" }} />
                                            <col style={{ width: "14%" }} />
                                          </colgroup>
                                          <tbody>
                                            <tr>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {contractId ?? "-"}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {formatDate(item?.dateStartAt)}{" "}
                                                - {formatDate(item?.dateEndAt)}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {formatSlotTime(
                                                  item?.slotStartAt,
                                                )}{" "}
                                                -{" "}
                                                {formatSlotTime(
                                                  item?.slotEndAt,
                                                )}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {item?.requiredQty}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {item?.lowestBidQty ?? "-"} /{" "}
                                                {item?.lowestBidPrice ?? "-"}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                <button
                                                  onClick={() => {
                                                    setSelectedRequisitionId(
                                                      item?.id,
                                                    );
                                                    setBidHistoryModal(true);
                                                  }}
                                                  className={
                                                    Styles.viewBidHistoryBtn
                                                  }
                                                >
                                                  View
                                                </button>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </React.Fragment>
                                    );
                                  })}
                                </>
                              ) : (
                                <>
                                  {reqData.map((item, idx) => {
                                    // Show every requisition returned by the API,
                                    // regardless of the self bid's award status.
                                    return (
                                      <React.Fragment key={idx}>
                                        <table
                                          className={Styles.summaryTable}
                                          style={{
                                            tableLayout: "fixed",
                                            width: "100%",
                                          }}
                                        >
                                          <colgroup>
                                            <col style={{ width: "16%" }} />
                                            <col style={{ width: "14%" }} />
                                            <col style={{ width: "22%" }} />
                                            <col style={{ width: "14%" }} />
                                            <col style={{ width: "20%" }} />
                                            <col style={{ width: "14%" }} />
                                          </colgroup>
                                          <tbody>
                                            <tr>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {contractId ?? "-"}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {formatDate(item?.dateStartAt)}{" "}
                                                - {formatDate(item?.dateEndAt)}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {formatSlotTime(
                                                  item?.slotStartAt,
                                                )}{" "}
                                                -{" "}
                                                {formatSlotTime(
                                                  item?.slotEndAt,
                                                )}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {item?.requiredQty}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                {item?.lowestBidQty ?? "-"} /{" "}
                                                {item?.lowestBidPrice ?? "-"}
                                              </td>
                                              <td
                                                className={Styles.summaryCell}
                                              >
                                                <button
                                                  onClick={() => {
                                                    setSelectedRequisitionId(
                                                      item?.id,
                                                    );
                                                    setBidHistoryModal(true);
                                                  }}
                                                  className={
                                                    Styles.viewBidHistoryBtn
                                                  }
                                                >
                                                  View
                                                </button>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </React.Fragment>
                                    );
                                  })}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {" "}
                              {reqData.map((item, idx) => {
                                return (
                                  <>
                                    <table
                                      key={idx}
                                      className={Styles.summaryTable}
                                      style={{
                                        tableLayout: "fixed",
                                        width: "100%",
                                      }}
                                    >
                                      <colgroup>
                                        {status?.toLowerCase() ===
                                        "withdrawn" ? (
                                          <>
                                            <col style={{ width: "15%" }} />
                                            <col style={{ width: "30%" }} />
                                            <col style={{ width: "28%" }} />
                                            <col style={{ width: "27%" }} />
                                          </>
                                        ) : (
                                          <>
                                            <col style={{ width: "14%" }} />
                                            <col style={{ width: "12%" }} />
                                            <col style={{ width: "24%" }} />
                                            <col style={{ width: "16%" }} />
                                            <col style={{ width: "20%" }} />
                                            <col style={{ width: "14%" }} />
                                          </>
                                        )}
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          {!isWithdrawn && (
                                            <td className={Styles.summaryCell}>
                                              {contractId ?? "-"}
                                            </td>
                                          )}
                                          <td className={Styles.summaryCell}>
                                            {formatDate(item?.dateStartAt)} -{" "}
                                            {formatDate(item?.dateEndAt)}
                                          </td>
                                          <td className={Styles.summaryCell}>
                                            {formatSlotTime(item?.slotStartAt)}{" "}
                                            - {formatSlotTime(item?.slotEndAt)}
                                          </td>
                                          <td className={Styles.summaryCell}>
                                            {item?.requiredQty}
                                          </td>
                                          {status?.toLowerCase() !==
                                            "withdrawn" && (
                                            <td className={Styles.summaryCell}>
                                              {item?.lowestBidQty ?? "-"} /{" "}
                                              {item?.lowestBidPrice ?? "-"}
                                            </td>
                                          )}
                                          <td className={Styles.summaryCell}>
                                            <button
                                              onClick={() => {
                                                setSelectedRequisitionId(
                                                  item?.id,
                                                );
                                                setBidHistoryModal(true);
                                              }}
                                              className={
                                                Styles.viewBidHistoryBtn
                                              }
                                            >
                                              View
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </>
                                );
                              })}
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className={Styles.noDataContainer}>
                      No matching records
                    </div>
                  )}
                  <div
                    className={Styles.statusBtnContainer}
                    style={{ paddingRight: "15px" }}
                  >
                    <div className={Styles.leftSideBtnContainer}>
                      <button
                        title={
                          ele?.tenderDoc
                            ? "View General Terms & Conditions"
                            : "General T&C not available"
                        }
                        onClick={() =>
                          handlePreviewGeneralTerms(ele?.tenderDoc)
                        }
                        disabled={!ele?.tenderDoc}
                        style={{
                          cursor: ele?.tenderDoc ? "pointer" : "not-allowed",
                          opacity: ele?.tenderDoc ? 1 : 0.6,
                        }}
                        className={Styles.leftSideBtn}
                      >
                        General T&C
                        <CallMadeIcon
                          style={{
                            fontSize: "8px",
                            position: "absolute",
                            top: "0px",
                          }}
                        />
                      </button>
                      <button
                        onClick={() =>
                          handlePreviewGeneralTerms(systemTnCUrl, {
                            hideHeader: true,
                          })
                        }
                        className={Styles.leftSideBtn}
                      >
                        T&C
                        <CallMadeOutlinedIcon
                          style={{
                            fontSize: "10px",
                            position: "absolute",
                            top: "-2px",
                          }}
                        />
                      </button>
                      {/* {Array.isArray(reqData) && reqData.length > 0 && (
                        <button
                          onClick={() => setBidsModal(true)}
                          className={Styles.leftSideBtn}
                        >
                          Selected Bids
                          <CallMadeIcon
                            style={{
                              fontSize: "8px",
                              position: "absolute",
                              top: "0px",
                            }}
                          />
                        </button>
                      )} */}
                      {/* {(connection?.id || ele?.tenderStatus === "TERMS") && (
                        <>
                          <button
                            onClick={() => setChargesModal(true)}
                            className={Styles.leftSideBtn}
                          >
                            View Charges
                            <CallMadeIcon
                              style={{
                                fontSize: "8px",
                                position: "absolute",
                                top: "0px",
                              }}
                            />
                          </button>
                          <button
                            onClick={() => setDocsModal(true)}
                            className={Styles.leftSideBtn}
                          >
                            View Docs
                            <CallMadeIcon
                              style={{
                                fontSize: "8px",
                                position: "absolute",
                                top: "0px",
                              }}
                            />
                          </button>
                        </>
                      )} */}
                    </div>
                    {ele?.tenderStatus === "TERMS" && (
                      <div style={{ display: "flex", gap: "8px" }}>
                        <button
                          onClick={() => {
                            let capId;
                            if (isInitiator) {
                              capId = ele?.capacityId;
                            } else {
                              capId =
                                ele?.generatorCapacityId ||
                                ele?.consumerCapacityId;
                            }
                            localStorage.setItem("activetenderId", ele?.id);
                            // remember the expanded listing so it can be
                            // restored when the user clicks Back from the
                            // tender details page.
                            sessionStorage.setItem(
                              EXPANDED_TENDER_KEY,
                              String(ele?.id),
                            );
                            dispatch(activeTenderId(ele?.id));
                            navigate(
                              `/tender_active?id=${capId}&source=archive`,
                            );
                          }}
                          className={Styles.rightSideBtn}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          View Details
                          <CallMadeIcon
                            style={{ fontSize: "10px", paddingBottom: "15px" }}
                          />
                        </button>
                        <button
                          onClick={handleDownloadTenderRes}
                          className={Styles.rightSideBtn}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <SaveAltIcon style={{ fontSize: "14px" }} />
                          Result
                        </button>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

const RAArchive = ({ type, status, auctionType }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [reqData, setReqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reqLoading, setReqLoading] = useState(false);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const userDataKey =
    role === "consumer" ? "capacityGenerator" : "capacityConsumer";
  const [expanded, setExpanded] = useState(0);
  // ensures we only restore the previously-expanded listing once per mount
  // (e.g. after returning from the tender details page), without overriding
  // the user's later manual interactions.
  const didRestoreExpanded = useRef(false);

  useEffect(() => {
    setExpanded(0);
  }, [type, status, auctionType]);

  const handleAccordionChange = useCallback(
    (val) => {
      setExpanded((prev) => (prev === val ? -1 : Number(val)));
    },
    [setExpanded],
  );

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const handleLoadMore = () => setPage((prev) => prev + 1);

  useEffect(() => {
    setExpanded(0);
    setPage(0);
    setData([]);
  }, [type, status, auctionType]);

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      try {
        setLoading(true);
        const res = await getRaArchive({
          role,
          status,
          auctionType,
          page: page,
          size: 10,
        });
        if (!mounted) return;
        if (res?.data?.code === 200) {
          const newData = res.data.data.page || [];
          setData((prevData) =>
            page === 0 ? newData : [...prevData, ...newData],
          );
          const { totalPages, currentPage } = res.data.data;
          setHasMore(currentPage < totalPages - 1);
        } else {
          setData([]);
          setHasMore(false);
        }
      } catch (error) {
        if (mounted) console.error("Error fetching archive data:", error);
        if (mounted) {
          setData([]);
          setHasMore(false);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => {
      mounted = false;
    };
  }, [type, status, role, page, auctionType]);

  // Restore the listing that was expanded before navigating to the tender
  // details page, so clicking Back returns the user to the same listing
  // instead of resetting to the first one.
  useEffect(() => {
    if (didRestoreExpanded.current) return;
    if (!Array.isArray(data) || data.length === 0) return;

    const savedId = sessionStorage.getItem(EXPANDED_TENDER_KEY);
    if (savedId) {
      const idx = data.findIndex((d) => String(d?.id) === savedId);
      if (idx >= 0) setExpanded(idx);
      sessionStorage.removeItem(EXPANDED_TENDER_KEY);
    }
    didRestoreExpanded.current = true;
  }, [data]);

  const fetchRaReqData = useCallback(
    async ({ id, bidStage }) => {
      try {
        setReqLoading(true);

        if (role === "generator") {
          let res = await getequisitionsBidders(id, bidStage);
          if (res?.data?.code === 200) setReqData(res?.data?.data);
        } else {
          let res = await getequisitionsList(id, bidStage);
          if (res?.data?.code === 200) setReqData(res?.data?.data);
        }
      } catch (error) {
        console.error("Error fetching RA Request Data:", error);
      } finally {
        setReqLoading(false);
      }
    },
    [role],
  );

  useEffect(() => {
    if (!Array.isArray(data) || expanded === -1) return;
    const item = data[expanded];
    const capId = item?.id;
    if (!capId) return;

    fetchRaReqData({
      id: capId,
      bidStage: ["ra_ongoing", "tender_closing_soon", "closed"].includes(
        status?.toLowerCase(),
      )
        ? "AUCTION"
        : "CB",
    });
    const connectionCapId =
      role === "generator" ? item?.generatorCapacityId : item?.capacityId;
    if (connectionCapId) {
      dispatch(fetchMainScreenActiveConnection({ capId: connectionCapId }));
    }
  }, [data, dispatch, expanded, fetchRaReqData, role, status]);

  return (
    <>
      <div
        style={{
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          overflowX: "hidden",
          paddingRight: "4px",
        }}
      >
        <LoaderNoData loading={loading} dataLength={data?.length ?? 0} />

        <>
          {data?.length > 0 && <SummaryHeader status={status} />}
          {
            <LoadMorePagination
              hasMore={hasMore}
              onLoadMore={handleLoadMore}
              loading={loading}
            >
              {" "}
              {data?.map((ele, index) => (
                <SummaryRow
                  key={ele?.id ?? ele?.name ?? index}
                  ele={ele}
                  reqLoading={reqLoading}
                  index={index}
                  reqData={reqData}
                  expanded={expanded}
                  onToggle={handleAccordionChange}
                  userDataKey={userDataKey}
                  role={role}
                  status={status}
                />
              ))}
            </LoadMorePagination>
          }
        </>
      </div>
    </>
  );
};

export default RAArchive;
